import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// material-ui
import { Box, ButtonBase, Grid, Stack, useTheme } from '@mui/material';

// project import
import Logo from '../../../view-components/Logo';
import AuthFooter from '../../../view-components/cards/AuthFooter';
import Snackbar from '../../../views/landing/components/Snackbar';

// assets
import AuthBackground from '../../../assets/images/auth/AuthBackground';
import { Link } from 'react-router-dom';
import MainCard from '../../../view-components/MainCard';
import { clearSnackBarMessage, setSnackBarOpen } from '../../../store/reducers/snackBarMessages';
import { store } from '../../../store';
import { logger } from '../../../utils/logger';

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthenticationLayout = ({ children }) => {
    const theme = useTheme();

    let snackBarOpen = useSelector((state) => state.snackBarMessages.snackBarOpen);
    let snackBarMessage = useSelector((state) => state.snackBarMessages.snackBarMessage);
    let snackBarMessageType = useSelector((state) => state.snackBarMessages.snackBarMessageType);

    const handleSnackBarClose = () => {
        store.dispatch(setSnackBarOpen(false));
        store.dispatch(clearSnackBarMessage());
    };

    useEffect(() => {
        (async () => {
            logger.log(snackBarMessage);
            if (snackBarMessage != '') {
                store.dispatch(setSnackBarOpen(true));
            } else {
                store.dispatch(setSnackBarOpen(false));
            }
        })();
    }, [snackBarMessage]);
    return (
        <Box sx={{ minHeight: '100vh' }}>
            <AuthBackground />
            <Stack
                direction="column"
                justifyContent="flex-end"
                sx={{
                    minHeight: '100vh'
                }}
            >
                <Box sx={{ ml: 3, mt: 3 }}>
                    <ButtonBase disableRipple component={Link} to="/">
                        <Logo />
                    </ButtonBase>
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            minHeight: { xs: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)' },
                            px: { xs: 2, sm: 0 }
                        }}
                    >
                        <Grid sx={{ width: { xs: '100%', sm: 'auto' } }}>
                            <MainCard
                                sx={{
                                    maxWidth: { xs: '100%', sm: 500, lg: 575 },
                                    width: '100%',
                                    '& > *': {
                                        flexGrow: 1,
                                        flexBasis: '100%'
                                    },
                                    backgroundColor: theme.palette.background.paper
                                }}
                                content={false}
                                border={false}
                                boxShadow
                            >
                                <Box
                                    sx={{
                                        p: { xs: 2, sm: 3, md: 4, xl: 5 },
                                        width: '100%',
                                        maxWidth: { sm: 500 },
                                        minHeight: { xs: 'auto', sm: 450 },
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    {children}
                                </Box>
                            </MainCard>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ m: 3, mt: 1 }}>
                    <AuthFooter />
                </Box>
            </Stack>
            <Snackbar open={snackBarOpen} closeFunc={handleSnackBarClose} message={snackBarMessage} alertColor={snackBarMessageType} />
        </Box>
    );
};

AuthenticationLayout.propTypes = {
    children: PropTypes.node
};

export default AuthenticationLayout;
